import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Company } from 'app/models/company.model';
import { Envanter } from 'app/models/envanter.model';
import { User } from 'app/models/user.model';
import { CompanyService } from 'app/services/company.service';
import { EnvanterService } from 'app/services/envanter.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { BaseFormComponent } from '../../base-form.component';
import { Device } from 'app/models/device.model';
import { DeviceService } from 'app/services/device.service';

@Component({
    selector: 'app-device-company-update',
    templateUrl: './device-company-update.component.html',
    styleUrls: ['./device-company-update.component.scss']
})
export class DeviceCompanyUpdateComponent extends BaseFormComponent implements OnInit {
    public selectedCompany: number;
    public companyId: number;
    public companyList: Array<Company> = [];


    private _model: Device;
    public get model(): Device {
        return this._model;
    }
    public set model(v: Device) {
        this._model = v;
    }

    constructor(
        private _toasterService: ToasterService,
        private _companyService: CompanyService,
        private _deviceService:DeviceService,
        private _translateService: TranslateService
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        try {
            this.companyId = parseInt(localStorage.getItem("CompanyID"))
            this.companyList = await this._companyService.getCompanies();
            this.selectedCompany = this.model.companyId;
        } catch (error) {
            console.warn(error);

        }
    }

    async submit(e) {
        this.model.company = null;
        this.model.companyId = parseInt(localStorage.getItem("CompanyID")) ? this.selectedCompany : parseInt(localStorage.getItem("CompanyID"))
        if (e.invalid) {
            this._toasterService.toastWarning(
                this._translateService.instant("PLEASE_FILL_IN_THE_FORM_CORRECTLY")
            );
            return;
        }
        try {
            await this._deviceService.updated(this.model);
            this.updated.emit(true)
        } catch (error) {
            console.warn(error);
            this.updated.emit(false)
        }
    }

}
